export const environment = {
    production: true,
    apiHost: 'https://loopedin-api.groupworkguru.com',
    uiHost: 'https://loopedin.groupworkguru.com',
    cookieDomain: 'groupworkguru.com',

    userPoolClientId: '6klomttdn1pg4b3ea57k1rf0ot',
    userPoolId: 'ap-southeast-2_cNH7iroNd',
    identityPoolId: "us-west-2:f0eaf4a7-81b5-4c77-8c95-388d9050251e",

    awsMqttHost: 'd01668903r7gbv9d8m4er-ats.iot.ap-southeast-2.amazonaws.com',
    awsRegion: 'ap-southeast-2'
}
